import { Selector } from '@ngxs/store';
import { AdminStateInterface, PaginationState, UserProfile } from '../models/admin.model';
import { AdminState } from '../reducers/admin.reducers';

export class AdminSelectors {
    @Selector([AdminState])
    static getSelectedCountries(state: AdminStateInterface): string[] {
        return state.selectedCountries;
    }

    @Selector([AdminState])
    static getSelectedVehicle(state: AdminStateInterface): string | null {
        return state.selectedVehicle;
    }

    @Selector([AdminState])
    static getVehicleDetails(state: AdminStateInterface): any {
        return state.vehicleDetails;
    }

    @Selector([AdminState])
    static getUserProfile(state: AdminStateInterface): UserProfile | null {
        return state.userProfile;
    }

    @Selector([AdminState])
    static getPagination(state: AdminStateInterface): PaginationState {
        return state.pagination;
    }

    @Selector([AdminState])
    static getSort(state: AdminStateInterface): string {
        return state.sort;
    }
}
